import PivotGridMeasureProps from './Measures'

let KendoPivotGridMeasure = {
    name: 'kendo-pivot-measure',
    render () {
        return null
    },
    mixins: [PivotGridMeasureProps]
}

export default KendoPivotGridMeasure


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotMeasure/index.js